<!-- <div class="pdfContain" style="margin: 0 auto; width: 14cm; border:1px solid #e9e9e9; position: fixed; left: -1000px; top: 0;"></div> -->
<div class="pdfContain"
  style="margin: 0 auto; width: 15cm; border:1px solid #e9e9e9;position: fixed; left: -1000px; top: 0;">
  <kendo-pdf-export #pdf margin="1cm" paperSize="A4" [repeatHeaders]="repeatHeaders"
    keepTogether=".keep-together,.chart-with-legend">
    <ng-template #pdfHeadingContent>
      <div class="pdf-heading col-12">
        <img class="app-logo-pdf" [src]="logoSrc" alt="App logo">
        <h1 class="section-title">{{ complianceTitle | translate | labelSanitizer }}</h1>
        <h1 class="section-title" *ngIf="complianceTitle == 'Sub-step compliance' && !subStepDetail">
          {{ ' ( ' + ('GENERAL.WITHOUT_SUB_PROCESS' | translate) + ' )' }}
        </h1>
      </div>
    </ng-template>
    <div class="a4Width pdf-content" id="mytable">
      <div class="pdf-heading-inline" aria-hidden="true">
        <ng-container [ngTemplateOutlet]="pdfHeadingContent"></ng-container>
      </div>
      <table class="table-no-border">
        <tbody style="background-color: white;">
          <div class="col-12 pr-4">
            <ng-container *ngFor="let result of results; let i = index">
              <div class="row keep-together">
                <div class="chart mt-2 chart-container" *ngFor="let chart of result.charts">
                  <lib-ph-bhp-bar-chart #charts [type]="'bar'" [mchartaxDivisions]='10' [maxBar]='10'
                    [barLabelPosition]="'insideEnd'" [isExportReport]="true">
                  </lib-ph-bhp-bar-chart>
                </div>
              </div>
              <div class="row">
                <div class="mt-2 col-12 d-flex p-0">
                  <div class="col p-0" *ngIf="result.fieldsGroup?.length > 0">
                    <label>{{ 'EVALUATION.REPORT.CAPTION_TABLES' | translate }}</label>
                  </div>
                </div>
                <div class="grid mt-2">
                  <div *ngFor="let fieldsGroup of result.fieldsGroup; let multiIndex = index"
                    class="table-wrapper keep-together">
                    <table class="table table-border my-2">
                      <tr>
                        <th>{{'EVALUATION.FILTER' | translate | labelSanitizer}}</th>
                        <th [attr.colspan]="result.filterColspan">
                          <div class="filter-box-container">
                            <div class="filter-box-pdf" [ngClass]="fieldsGroup[0].filterClass"></div>
                            <span>
                              {{ (fieldsGroup[0].group || '') | translate | labelSanitizer }}
                            </span>
                          </div>
                        </th>
                      </tr>
                      <tr *ngIf="result.isMultifilter">
                        <th></th>
                        <th *ngFor="let multiHeader of result.multiBreaks[multiIndex]"
                          [attr.colspan]="result.multiColspan">
                          {{ multiHeader.title | translate | labelSanitizer }}
                        </th>
                      </tr>
                      <tr>
                        <th>{{'EVALUATION.TITLE' | translate | labelSanitizer }}</th>
                        <th *ngFor="let field of fieldsGroup">
                          {{ field.title | translate | labelSanitizer }}
                        </th>
                      </tr>
                      <tbody>
                        <tr *ngFor="let data of result.gridData">
                          <td>{{ data['title']}}</td>
                          <td *ngFor="let field of fieldsGroup">
                            {{ getData(data[field.field]) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </ng-container>
            <div class="row">
              <div class="mt-2 col-12 d-flex p-0">
                  <div class="col p-0" >
                    <label>{{ 'EVALUATION.REPORT.CAPTION_FILTERS' | translate }}</label>
                  </div>
                </div>
              <div class="filters-section" [ngClass]="{'page-break': hasMultipleFilters()}" #filterDetails>
                <div class="mt-2 col-12 d-flex p-0">
                  <div class="col p-0" *ngIf="SOPName">
                    <label>{{ 'EVALUATION.SOP' | translate }}1</label>
                    <div>{{ SOPName | translate | labelSanitizer }}</div>
                  </div>

                  <div class="col p-0" *ngIf="!SOPName  && !isObserve">
                    <label>{{ 'EVALUATION.SOP' | translate }}1</label>
                    <ul>
                      <li *ngFor="let step of SOPList"> {{ step.title | translate | labelSanitizer}}</li>
                    </ul>
                  </div>
                  <div class="col p-0" *ngIf="Steps">
                    <label>{{ 'EVALUATION.STEPS' | translate }}</label>
                    <div>{{ Steps | translate | labelSanitizer }}</div>
                  </div>

                  <div class="col p-0" *ngIf="specificStep">
                    <label>{{ 'EVALUATION.SPECIFIC_STEPS' | translate }}</label>
                    <div>
                      <ul>
                        <li *ngFor="let step of specificStep"> {{ step.stepTittle | translate | labelSanitizer}}</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div *ngFor="let filterData of filtersData; let i = index" class="mt-2 col-12 d-flex p-0"
                  [hidden]="!showFilter && i === 0 || !showCompareCard && i === 1">
                  <div *ngIf="showFilterData(filterData)" class="filter-container keep-together">
                    <div class="filter-box-container mb-2">
                      <div class="filter-box-pdf"
                        [ngClass]="{ 'filter-box-1' : i == 0, 'filter-box-2': i == 1, 'filter-box-3' : i == 2, 'filter-box-4' : i == 3, 'filter-box-5' : i == 4, 'filter-box-6' : i == 5}">
                      </div>
                      <label class="filter-box-text">{{ filterData.setFilterName }}</label>
                    </div>
                    <div>
                      <span>{{ filterData.formattedDateRange }}</span>
                    </div>
                    <div>
                      <span class="resultBox"
                        *ngIf="filterData.setCountry && roleId == 1">{{filterData.setCountry.countryName | translate}}
                      </span>
                      <span class="resultBox" *ngIf="!filterData.setCountry && roleId == 1">{{
                        'EVALUATION.All.COUNTRIES' | translate }} </span>
                      <span class="resultBox"
                        *ngIf="filterData.setInstitution">{{filterData.setInstitution.institutionName |
                        labelSanitizer}} </span>
                      <span class="resultBox" *ngIf="!filterData.setInstitution">{{ 'EVALUATION.All.INSTITUTIONS' |
                        translate }} </span>
                      <span class="resultBox" *ngIf="filterData.setWard && filterData.multiSelect!='ward'">{{
                        filterData.setWard.wardName | translate |
                        labelSanitizer}} </span>
                      <span class="resultBox" *ngIf="!filterData.setWard && filterData.multiSelect!='ward'">{{
                        'EVALUATION.All.WARDS' | translate }}
                      </span>
                      <span class="resultBox" *ngIf="filterData.setDepartment && filterData.multiSelect!='dept'">{{
                        filterData.setDepartment.departmentName | translate | labelSanitizer}} </span>
                      <span class="resultBox" *ngIf="!filterData.setDepartment && filterData.multiSelect!='dept'">{{
                        'EVALUATION.All.DEPARTMENTS' |
                        translate }} </span>
                      <span class="resultBox"
                        *ngIf="filterData.setDepartmentType && filterData.multiSelect!='deptType'">{{
                        filterData.setDepartmentType.departmentTypeName | translate | labelSanitizer}} </span>
                      <span class="resultBox"
                        *ngIf="!filterData.setDepartmentType && filterData.multiSelect!='deptType'">{{
                        'EVALUATION.All.DEPARTMENT_TYPES' |
                        translate }} </span>
                      <span class="resultBox" *ngIf="filterData.setCategory && filterData.multiSelect!='cat'">{{
                        filterData.setCategory.categoryName |
                        translate | labelSanitizer}}</span>
                      <span class="resultBox" *ngIf="!filterData.setCategory && filterData.multiSelect!='cat'">{{
                        'EVALUATION.All.PROFESSIONAL_CATEGORIES' | translate }} </span>
                      <div *ngIf="showProfessionalSubcategory && filterData.multiSelect!='subCat'">
                        <span class="resultBox"
                          *ngIf="filterData.setSubCategory">{{filterData.setSubCategory.subCategoryName | translate |
                          labelSanitizer}} </span>
                        <span class="resultBox" *ngIf="!filterData.setCategory">{{
                          'EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES' | translate }} </span>
                      </div>
                      <span *ngIf="filterData.multiValues.length > 0" class="resultBox first">{{'MultiValues:'}}</span>
                      <span class="resultBox" *ngFor="let value of filterData.multiValues || []">
                        {{value | translate | labelSanitizer}}
                      </span>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tbody>
      </table>
    </div>

    <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
      <div class="pdf-page-template">
        <div class="pdf-heading-wrapper">
          <ng-container [ngTemplateOutlet]="pdfHeadingContent"></ng-container>
        </div>
        <div class="pageNum">
          {{ 'GENERAL.PAGE'| translate }} {{ pageNum }} {{ 'GENERAL.OF' | translate }} {{ totalPages }}
        </div>
      </div>
    </ng-template>
  </kendo-pdf-export>
</div>
